(function () {
function initializeColorVariantSelection() {
  if (window.location.pathname.includes('/products/')) {
    const colorRadioInputs = document.querySelectorAll('input[type="radio"][name*="Color"], input[type="radio"][name*="PRINT COLOR"]');
    const productThumbnail = document.querySelector('.main-media-wrapper .product-thumbnail img');
    // Find all images inside .milk-product-media wrapper
    let mediaSlidesImgs = document.querySelectorAll(' .milk-product-media img');

    colorRadioInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        // Re-query in case DOM changed
        mediaSlidesImgs = document.querySelectorAll('.milk-product-media img');
        const selectedColor = input.value.toLowerCase();
        let matchingMedia = null;
        let matchingImgIndex = -1;

        mediaSlidesImgs.forEach((img, index) => {
          const altText = img ? img.alt.toLowerCase() : '';
          if (altText.includes(selectedColor)) {
            matchingMedia = img;
            matchingImgIndex = index;
          }
        });

        // Update the desktop thumbnail
        if (matchingMedia && productThumbnail) {
          productThumbnail.src = matchingMedia.src;
          productThumbnail.alt = matchingMedia.alt;
        }

        // Update the gallery for mobile and desktop
        if (matchingImgIndex >= 0) {
          mediaSlidesImgs.forEach((img, index) => {
            if (index === matchingImgIndex) {
              img.classList.add('is-active');
            } else {
              img.classList.remove('is-active');
            }
          });

          // Only scroll for mobile devices
          const selectedImg = mediaSlidesImgs[matchingImgIndex];
          if (selectedImg && window.innerWidth <= 768) {
            selectedImg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {

  // Example inside your variant update or thumbnail click logic:
document.querySelectorAll('.desktop-media-thumbnail').forEach(img => {
  img.classList.remove('active');
});

// Find the matching thumbnail for the current variant
const variantId = document.querySelector('[name="id"]')?.value;
let matchingImg = null;
document.querySelectorAll('.desktop-media-thumbnail').forEach(img => {
  // You may need to match by data-media-id or src depending on your setup
  if (img.dataset.mediaId == variantId || img.classList.contains('is-active')) {
    matchingImg = img;
  }
});

if (matchingImg) {
  matchingImg.classList.add('active');
}
  const scrollWrapper = document.querySelector(".thumbnail-scroll-wrapper");
  const scrollContent = scrollWrapper?.querySelector(".scrollable-thumbnails");

  if (!scrollWrapper || !scrollContent) return;

  const updateShadows = () => {
    const scrollLeft = scrollContent.scrollLeft;
    const scrollRight = scrollContent.scrollWidth - scrollContent.clientWidth - scrollLeft;

    scrollWrapper.classList.toggle("show-left-shadow", scrollLeft > 2);
    scrollWrapper.classList.toggle("show-right-shadow", scrollRight > 2);
  };

  scrollContent.addEventListener("scroll", updateShadows);
  window.addEventListener("resize", updateShadows);

  // Initial check
  updateShadows();
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/products/')) {
    document.body.classList.add('product-page');
  }

  if (window.location.pathname.includes('/collections/all')) {
    document.body.classList.add('all-products-page');
  }

  if (window.location.pathname.includes('/cart')) {
    document.body.classList.add('cart-page');
  }
});

document.addEventListener('DOMContentLoaded', initializeColorVariantSelection);

function revealProductPage() {
  if (!document.body.classList.contains('product-page')) return;
  if (document.body.classList.contains('product-page--ready')) return;
  document.body.classList.add('product-page--ready');
}

function waitForImage(img) {
  return new Promise((resolve) => {
    if (!img || (img.complete && img.naturalHeight !== 0)) {
      resolve();
      return;
    }

    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', resolve, { once: true });
  });
}

async function initProductPageReady() {
  if (!window.location.pathname.includes('/products/')) return;

  const mediaWrapper = document.querySelector('.main-media-wrapper');
  const productThumbnailImg = document.querySelector('.product-thumbnail img');
  const hasImages = mediaWrapper && mediaWrapper.querySelectorAll('img').length > 0;
  const isNoMedia = mediaWrapper?.classList.contains('main-media-wrapper--no-media');

  if (!hasImages || isNoMedia) {
    revealProductPage();
    return;
  }

  const isSingleMedia = document.querySelector('.product--single-media');
  const imagesToLoad =
    window.innerWidth >= 750 || isSingleMedia
      ? [productThumbnailImg].filter(Boolean)
      : Array.from(mediaWrapper.querySelectorAll('img')).slice(0, 3);

  await Promise.race([
    Promise.all(imagesToLoad.map(waitForImage)),
    new Promise((resolve) => setTimeout(resolve, 4000)),
  ]);

  revealProductPage();
}

document.addEventListener('DOMContentLoaded', initProductPageReady);

// --- Begin: product-media-gallery.liquid gallery logic ---
document.addEventListener('DOMContentLoaded', async () => {

  // Get all images inside .milk-product-media
  const galleryImages = document.querySelectorAll('.milk-product-media slider');
  const featured = document.querySelector('.featured__media img');
  const thumb = document.querySelector('.product-thumbnail img');
  const variantDataElem = document.getElementById('variantData');
  const data = variantDataElem ? JSON.parse(variantDataElem.textContent) : [];
  const modal = document.getElementById('fullscreenModal');
  const modalImg = document.getElementById('fullscreenImage');
  const closeBtn = modal?.querySelector('.close');

function normalize(src) {
  let url = src?.startsWith('http') ? src : `https:${src}`;

  // Remove width query param (e.g., ?width=1200 or &width=1200)
  url = url.replace(/([&?])width=\d+/g, '');
  url = url.replace(/[?&]$/, ''); // Remove dangling ? or &

  // Remove known Shopify image size suffixes (e.g. _120x, _large, _medium) before extension
  url = url.replace(/(_(?:\d+x|pico|icon|thumb|small|compact|medium|large|grande|original|master))(?=\.\w{3,4}(\?|$))/i, '');
  return url;
}

function updateMain(rawSrc) {
  const normalized = normalize(rawSrc);
  const baseOnly = normalized.replace(/^https?:/, '');

  const featured = document.querySelector('.featured__media img');
  const thumb = document.querySelector('.product-thumbnail img');

  console.log("Updating main image with normalized src: ", normalized);
  if (thumb) thumb.src = normalized;
  if (featured) featured.src = normalized;

  // Mobile gallery scroll
  const galleryUl = document.querySelector('ul.milk-product-media.slider--mobile');
  if (galleryUl) {
    const matchedLi = Array.from(galleryUl.querySelectorAll('li')).find(li => {
      const img = li.querySelector('img');
      return img && normalize(img.src).includes(baseOnly);
    });
    if (matchedLi) {
      matchedLi.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      galleryUl.querySelectorAll('img').forEach(img => img.classList.remove('selected'));
      const selectedImg = matchedLi.querySelector('img');
      if (selectedImg) selectedImg.classList.add('selected');
    }
  }

  // Desktop thumbnail highlight
document.querySelectorAll('.desktop-media-thumbnail').forEach(img => {
  const imgNormalized = normalize(img.src);
  if (imgNormalized.includes(baseOnly)) {
    img.classList.add('active');
  } else {
    img.classList.remove('active');
  }
});
}

  function updateVariant() {
    const id = new URLSearchParams(location.search).get('variant');
    const variant = data.find(x => String(x.id) === id);
    if (!variant) return;

    const rawSrc = variant.featured_media?.preview_image?.src || variant.featured_image?.src;

    if (rawSrc) updateMain(rawSrc);
  }

function getFileNameBase(url) {
  // Extract filename from path: grey_front_120x.webp -> grey_front
  const match = url.match(/\/([^\/?]+?)(?:_[0-9]+x)?\.webp/i);
  return match ? match[1] : '';
}

function updateVariantFromDesktopThumbnail(imgSrc) {
  const clickedBase = getFileNameBase(imgSrc);

  const variant = data.find(v => {
    const variantRawSrc = v.featured_media?.preview_image?.src || v.featured_image?.src || '';
    const variantBase = getFileNameBase(variantRawSrc);
    return variantBase === clickedBase;
  });

  if (variant) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.pushState({}, '', url.toString());
    updateVariant();
  }
}

  const overrideHistoryMethod = (method) => {
    const original = history[method];
    history[method] = (...args) => {
      original.apply(history, args);
      setTimeout(updateVariant, 0);
    };
  };

  overrideHistoryMethod('pushState');
  overrideHistoryMethod('replaceState');

  window.addEventListener('popstate', updateVariant);
  document.querySelectorAll('select[name^="options"]').forEach(select =>
    select.addEventListener('change', updateVariant)
  );

  updateVariant();

  // Ensure the thumbnail matching the image already shown as the main
  // product image starts out "active" instead of requiring a click.
  if (!document.querySelector('.desktop-media-thumbnail.active')) {
    const currentMainImg = document.querySelector('.main-media-wrapper .product-thumbnail img') || featured;
    if (currentMainImg?.src) {
      const baseOnly = normalize(currentMainImg.src).replace(/^https?:/, '');
      document.querySelectorAll('.desktop-media-thumbnail').forEach(img => {
        if (normalize(img.src).includes(baseOnly)) {
          img.classList.add('active');
        }
      });
    }
  }

  // if (featured) {
  //   featured.addEventListener('click', () => {
  //     if (modal && modalImg) {
  //       modal.style.display = 'flex';
  //       modalImg.src = featured.src;
  //     }
  //   });
  // }

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.thumbnail-scroll-wrapper');
  const scroller = wrapper.querySelector('.scrollable-thumbnails');
  const thumbnails = wrapper.querySelectorAll('.desktop-media-thumbnail');

  if (thumbnails.length < 2) return;

  const first = thumbnails[0];
  const last = thumbnails[thumbnails.length - 1];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.target === first) {
          wrapper.classList.toggle('has-left-shadow', !entry.isIntersecting);
        }
        if (entry.target === last) {
          wrapper.classList.toggle('has-right-shadow', !entry.isIntersecting);
        }
      });
    },
    {
      root: scroller,
      threshold: 1.0,
    }
  );

  observer.observe(first);
  observer.observe(last);
});
document.querySelectorAll('.desktop-media-thumbnail').forEach(img => {
  img.addEventListener('click', () => {
    const src = img.src;
    const normalized = normalize(src);
    updateMain(normalized);
    // updateVariantFromDesktopThumbnail(src);
  });
});

  galleryImages.forEach(img => {
    img.addEventListener('click', () => updateMain(img.src));
    img.addEventListener('mouseover', () => { if (featured) featured.src = normalize(img.src); });
    img.addEventListener('mouseout', () => { if (featured && thumb) featured.src = thumb.src; });
  });
});
})();

